export default __webpack_public_path__ + "static/media/goopter-retail-stores-hardware-features.49d6602d.png";